var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 53,
    viewBox: "0 0 180 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M173.333 52.2925H6.66667C3.00167 52.2925 0 49.3659 0 45.7925V6.79248C0 3.21911 3.00167 0.292483 6.66667 0.292483H173.333C176.998 0.292483 180 3.21911 180 6.79248V45.7925C180 49.3659 176.998 52.2925 173.333 52.2925Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9133 10.0928C13.5216 10.4926 13.2949 11.1149 13.2949 11.9209V40.6704C13.2949 41.4764 13.5216 42.0988 13.9133 42.4986L14.0099 42.5863L30.5332 26.4826V26.1023L14.0099 9.99855L13.9133 10.0928Z",
    fill: "url(#paint0_linear_9109_244390)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0349 31.8531L30.5332 26.4825V26.1023L36.0415 20.7317L36.1649 20.8015L42.6882 24.4204C44.5499 25.4474 44.5499 27.1374 42.6882 28.1709L36.1649 31.7833L36.0349 31.8531V31.8531Z",
    fill: "url(#paint1_linear_9109_244390)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1647 31.7833L30.5331 26.2925L13.9131 42.4986C14.5314 43.1323 15.5398 43.2087 16.6864 42.5749L36.1647 31.7833",
    fill: "url(#paint2_linear_9109_244390)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1647 20.8016L16.6864 10.01C15.5398 9.38274 14.5314 9.45911 13.9131 10.0929L30.5331 26.2925L36.1647 20.8016Z",
    fill: "url(#paint3_linear_9109_244390)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2234 13.6093C63.2234 14.6948 62.8901 15.5642 62.2334 16.2125C61.4784 16.9812 60.4951 17.3679 59.2901 17.3679C58.1384 17.3679 57.155 16.9747 56.3484 16.1995C55.54 15.413 55.1367 14.4478 55.1367 13.2924C55.1367 12.137 55.54 11.1718 56.3484 10.3918C57.155 9.61017 58.1384 9.21692 59.2901 9.21692C59.8634 9.21692 60.41 9.33229 60.9317 9.54679C61.4517 9.76292 61.875 10.0554 62.1817 10.4162L61.485 11.1019C60.95 10.486 60.2217 10.1822 59.2901 10.1822C58.4501 10.1822 57.7217 10.4682 57.1034 11.045C56.4917 11.6235 56.185 12.3727 56.185 13.2924C56.185 14.2122 56.4917 14.9678 57.1034 15.5463C57.7217 16.1167 58.4501 16.4092 59.2901 16.4092C60.1817 16.4092 60.9317 16.1167 61.5234 15.5398C61.9134 15.1579 62.1351 14.6314 62.1934 13.9587H59.2901V13.0194H63.1634C63.2101 13.2225 63.2234 13.4192 63.2234 13.6093V13.6093Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3685 10.3528H65.7302V12.8228H69.0102V13.762H65.7302V16.232H69.3685V17.1891H64.7002V9.39563H69.3685V10.3528Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73.705 17.1891H72.675V10.3528H70.4434V9.39563H75.9384V10.3528H73.705V17.1891V17.1891Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M79.915 17.1891V9.39563H80.9434V17.1891H79.915Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5019 17.1891H84.4802V10.3528H82.2402V9.39563H87.7419V10.3528H85.5019V17.1891Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1451 16.1865C97.3568 16.9747 96.3801 17.3679 95.2151 17.3679C94.0434 17.3679 93.0668 16.9747 92.2784 16.1865C91.4918 15.4 91.1001 14.4348 91.1001 13.2924C91.1001 12.15 91.4918 11.1848 92.2784 10.3983C93.0668 9.61017 94.0434 9.21692 95.2151 9.21692C96.3734 9.21692 97.3501 9.61017 98.1384 10.4048C98.9318 11.1978 99.3234 12.1565 99.3234 13.2924C99.3234 14.4348 98.9318 15.4 98.1451 16.1865ZM93.0401 15.5333C93.6334 16.1167 94.3551 16.4092 95.2151 16.4092C96.0684 16.4092 96.7968 16.1167 97.3834 15.5333C97.9751 14.9499 98.2751 14.2008 98.2751 13.2924C98.2751 12.384 97.9751 11.6349 97.3834 11.0515C96.7968 10.4682 96.0684 10.1757 95.2151 10.1757C94.3551 10.1757 93.6334 10.4682 93.0401 11.0515C92.4484 11.6349 92.1484 12.384 92.1484 13.2924C92.1484 14.2008 92.4484 14.9499 93.0401 15.5333V15.5333Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M100.769 17.1891V9.39563H102.019L105.905 15.4569H105.95L105.905 13.9586V9.39563H106.934V17.1891H105.86L101.79 10.8289H101.745L101.79 12.3336V17.1891H100.769V17.1891Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8469 28.5708C87.7152 28.5708 85.1569 30.8945 85.1569 34.1006C85.1569 37.2808 87.7152 39.6289 90.8469 39.6289C93.9852 39.6289 96.5435 37.2808 96.5435 34.1006C96.5435 30.8945 93.9852 28.5708 90.8469 28.5708ZM90.8469 37.4514C89.1285 37.4514 87.6502 36.0685 87.6502 34.1006C87.6502 32.1068 89.1285 30.7483 90.8469 30.7483C92.5652 30.7483 94.0502 32.1068 94.0502 34.1006C94.0502 36.0685 92.5652 37.4514 90.8469 37.4514V37.4514ZM78.4319 28.5708C75.2935 28.5708 72.7419 30.8945 72.7419 34.1006C72.7419 37.2808 75.2935 39.6289 78.4319 39.6289C81.5685 39.6289 84.1219 37.2808 84.1219 34.1006C84.1219 30.8945 81.5685 28.5708 78.4319 28.5708ZM78.4319 37.4514C76.7119 37.4514 75.2285 36.0685 75.2285 34.1006C75.2285 32.1068 76.7119 30.7483 78.4319 30.7483C80.1502 30.7483 81.6285 32.1068 81.6285 34.1006C81.6285 36.0685 80.1502 37.4514 78.4319 37.4514ZM63.6585 30.2656V32.6154H69.4135C69.2452 33.9284 68.7952 34.8936 68.1052 35.5664C67.2652 36.3789 65.9569 37.2808 63.6585 37.2808C60.1169 37.2808 57.3435 34.4939 57.3435 31.0408C57.3435 27.5876 60.1169 24.8008 63.6585 24.8008C65.5735 24.8008 66.9669 25.5304 67.9952 26.4761L69.6935 24.8203C68.2552 23.4813 66.3419 22.4526 63.6585 22.4526C58.8019 22.4526 54.7202 26.3055 54.7202 31.0408C54.7202 35.776 58.8019 39.6289 63.6585 39.6289C66.2835 39.6289 68.2552 38.7904 69.8052 37.2174C71.3935 35.6688 71.8885 33.4913 71.8885 31.733C71.8885 31.187 71.8419 30.6849 71.7585 30.2656H63.6585ZM124.069 32.0873C123.6 30.8506 122.155 28.5708 119.212 28.5708C116.295 28.5708 113.867 30.8116 113.867 34.1006C113.867 37.1979 116.27 39.6289 119.492 39.6289C122.097 39.6289 123.6 38.0803 124.219 37.1784L122.285 35.9223C121.64 36.842 120.762 37.4514 119.492 37.4514C118.23 37.4514 117.325 36.8875 116.745 35.776L124.33 32.7161L124.069 32.0873V32.0873ZM116.335 33.9284C116.27 31.7964 118.034 30.7044 119.297 30.7044C120.287 30.7044 121.127 31.187 121.407 31.8776L116.335 33.9284V33.9284ZM110.17 39.2925H112.664V23.0425H110.17V39.2925ZM106.087 29.8025H106.004C105.444 29.1558 104.375 28.5708 103.022 28.5708C100.182 28.5708 97.5852 31.0018 97.5852 34.1185C97.5852 37.2174 100.182 39.6289 103.022 39.6289C104.375 39.6289 105.444 39.039 106.004 38.3728H106.087V39.1658C106.087 41.2799 104.929 42.4158 103.06 42.4158C101.537 42.4158 100.592 41.3433 100.202 40.4414L98.0335 41.3238C98.6585 42.7895 100.314 44.5933 103.06 44.5933C105.984 44.5933 108.45 42.9163 108.45 38.8359V28.9071H106.087V29.8025V29.8025ZM103.235 37.4514C101.517 37.4514 100.079 36.049 100.079 34.1185C100.079 32.1701 101.517 30.7483 103.235 30.7483C104.929 30.7483 106.264 32.1701 106.264 34.1185C106.264 36.049 104.929 37.4514 103.235 37.4514V37.4514ZM135.742 23.0425H129.779V39.2925H132.265V33.1354H135.742C138.504 33.1354 141.212 31.187 141.212 28.0881C141.212 24.9909 138.497 23.0425 135.742 23.0425V23.0425ZM135.807 30.875H132.265V25.3029H135.807C137.664 25.3029 138.724 26.806 138.724 28.0881C138.724 29.3459 137.664 30.875 135.807 30.875ZM151.179 28.5399C149.382 28.5399 147.514 29.3134 146.745 31.0278L148.952 31.9296C149.427 31.0278 150.3 30.7353 151.224 30.7353C152.514 30.7353 153.822 31.4909 153.842 32.825V32.9956C153.392 32.7421 152.429 32.3668 151.244 32.3668C148.867 32.3668 146.445 33.6424 146.445 36.023C146.445 38.2005 148.392 39.6029 150.58 39.6029C152.254 39.6029 153.177 38.8668 153.757 38.0104H153.842V39.2665H156.244V33.033C156.244 30.1519 154.037 28.5399 151.179 28.5399ZM150.879 37.4449C150.065 37.4449 148.932 37.0516 148.932 36.0685C148.932 34.8108 150.345 34.3281 151.569 34.3281C152.664 34.3281 153.177 34.5638 153.842 34.8741C153.647 36.3789 152.319 37.4449 150.879 37.4449V37.4449ZM164.994 28.8958L162.135 35.9401H162.05L159.095 28.8958H156.414L160.854 38.74L158.32 44.2179H160.919L167.76 28.8958H164.994V28.8958ZM142.579 39.2925H145.072V23.0425H142.579V39.2925Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9109_244390",
    x1: 29.0662,
    y1: 40.9698,
    x2: 7.25605,
    y2: 18.6005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9109_244390",
    x1: 45.1124,
    y1: 26.2906,
    x2: 12.8499,
    y2: 26.2906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9109_244390",
    x1: 33.1024,
    y1: 23.3075,
    x2: 3.52611,
    y2: -7.02715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9109_244390",
    x1: 9.72949,
    y1: 52.0634,
    x2: 22.9366,
    y2: 38.5178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google_play.920e8699c5b61c0cb7d7aa11c2da2f1a.svg";
export { ForwardRef as ReactComponent };